module.exports = __webpack_public_path__ + "img/timothy-tan-PAe2UhGo-S4-unsplash.79fd0c5b.jpg";